import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=d5717432&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5717432')) {
      api.createRecord('d5717432', component.options)
    } else {
      api.reload('d5717432', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=d5717432&", function () {
      api.rerender('d5717432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/Home.vue"
export default component.exports